import React from 'react';
import TopSection from './TopSection';
import CourseNav from './CourseNav';
import Overview from './components/Overview';
import KeyFocus from './components/KeyFocus';
import Outcomes from './components/Outcomes';
import ProgrammeFormat from './components/ProgrammeFormat';
import Cost from './components/Cost';
import ContactUs from './components/ContactUs';
import ApplyNowForm from './components/ApplyNowForm';

const EEForGovenrmentOfficialsTemplate = ({ data }) => {
  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <TopSection data={data} />
      <CourseNav />
      <section id="overview" className=" scroll-mt-48">
        <Overview text={data.overviewText} />
      </section>
      <section id="keyFocus" className=" scroll-mt-48">
        <KeyFocus areas={data.keyFocusAreas} />
      </section>
      <section id="expectedOutcomes" className=" scroll-mt-48">
        <Outcomes outcomes={data.expectedOutcomes} />
      </section>
      <section id="programmeFormat" className=" scroll-mt-48">
        <ProgrammeFormat />
      </section>
      <section id="cost" className=" scroll-mt-48">
        <Cost />
      </section>
      <section id="contactUs" className=" scroll-mt-48">
        <ContactUs />
      </section>
      <section id="applyNow" className=" scroll-mt-48">
        <ApplyNowForm />
      </section>
    </div>
  );
};

export default EEForGovenrmentOfficialsTemplate;
